import { TextField } from '@mui/material'
import { FieldDef } from '../types'

interface Props {
  field: FieldDef
  value: string
  onChange: (v: string) => void
}

export default function TextWidget({ field, value, onChange }: Props) {
  return (
    <TextField
      label={field.label}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      size="small"
      required={field.required}
    />
  )
}
